module.exports = __webpack_public_path__ + "static/media/yves-saint-laurent-libre-big.00e308be.png";